

class MonostateExample
{
    constructor()
    {  
         this.getStateVar = function()
        {
            return MonostateExample.stateVar;
        }

        this.incrementStateVar = function()
        {
            ++MonostateExample.stateVar;
        } 
    } 
}
MonostateExample.stateVar = 1;
export default MonostateExample;


// WEBPACK FOOTER //
// ./src/components/EsPatterns/MonostateExample.js